'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const forEach = require('lodash/forEach');
const find = require('lodash/find');
const map = require('lodash/map');
const filter = require('lodash/filter');
const sortBy = require('lodash/sortBy');
const has = require('lodash/has');
const get = require('lodash/get');
import { Card, Button } from 'react-bootstrap';
import { Wrapper, Button as AriaButton, Menu, MenuItem } from 'react-aria-menubutton';

const Globals = require('../../../../app/globals');
const GlobalUserActions = require('../../actions/GlobalUserActions');
const AdminGlobalUserStore = require('../../stores/AdminGlobalUserStore');
const AssignmentStore = require('../../stores/AssignmentStore');
const AssignmentActions = require('../../actions/AssignmentActions');
const OrganizationMemberStore = require('../../stores/OrganizationMemberStore');
const OrganizationActions = require('../../actions/OrganizationActions');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');
import LoadingMainContent from '../loading/LoadingMainContent';
import DateString from '../common/DateString';
import SortableTableClassic from '../table/SortableTableClassic';
import RegisterOrganization from '../common/RegisterOrganization';
import ExpansionButton from '../common/ExpansionButton';
import AdminAddOrgOwnerModal from '../modal/AdminAddOrgOwnerModal';
import ConfirmModal from '../modal/ConfirmModal';
import ErrorBox from '../common/ErrorBox';
import AdminUserPartnerKeyEditor from './AdminUserPartnerKeyEditor';
import AdminLTISettingsView from './AdminLTISettingsView';
import AdminUserTemplatePermissionsEditor from './AdminUserTemplatePermissionsEditor';
import AdminAccountFeaturesEditor from './AdminAccountFeaturesEditor';
import AdminOrgWebSketchUploads from './AdminOrgWebSketchUploads';
import CourseStatsView from '../analytics/CourseStatsView';
import VoiceUsageView from './VoiceUsageView';
import ChatbotUsageView from './ChatbotUsageView';
import WarningBox from '../common/WarningBox';

const propTypes = {};
const defaultProps = {};

// statuses we can set a user to
const STATUS_VALUES = [
    Globals.ecommerce.subscription_statuses.trialing,
    Globals.ecommerce.subscription_statuses.active,
    Globals.ecommerce.subscription_statuses.past_due,
    Globals.ecommerce.subscription_statuses.canceled,
    Globals.ecommerce.subscription_statuses.unpaid,
    //Globals.ecommerce.subscription_statuses.none,
    //Globals.ecommerce.subscription_statuses.invalid,
];

let users = [];
const ORG_COLUMN_DATA = [
    {
        displayName: 'ID',
        key:'id',
        size: 1,
        type: 'int'
    },
    {
        displayName: 'Display Name',
        key:'display_name',
        size: 2,
        type: 'string'
    },
    {
        displayName: 'Created Date',
        key:'created_at',
        size: 3,
        type: 'date'
    },
    {
        displayName: 'Last Active',
        key:'active_at',
        size: 3,
        type: 'date'
    },
    {
        displayName: 'Email',
        key: 'email',
        size: 3,
        type: 'string'
    },
    {
        displayName: 'Acc. Type',
        key: 'account_type',
        size: 2,
        type: 'string'
    }
];

class AdminOrganizationView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userStoreState: AdminGlobalUserStore.getState(),
            subscriptionPlanStoreState: SubscriptionPlanStore.getState(),
            organizationMemberState: OrganizationMemberStore.getState(),
            assignmentStoreState: AssignmentStore.getState(),
            selectedUser: null, // Note: selectedUser is actually the selected organization ( an org is technically a type of user in our system )
            selectedOwner: null, // owner of a selected organization
            showOwnerDetails: false,
            showAddOwnerPanel: false,
            showRemoveOwnerConfirm: false,
            actionID: null,
            viewUserType: this.USER_AUTHORS,
            plan_error: null,
            userIdToDelete: null,
            deleteOrgModalVisible: false,
            deleteActionId: null,
        };

        this.getStateFromPlanStoreState = this.getStateFromPlanStoreState.bind(this);
        this.onSubscriptionPlanStoreChange = this.onSubscriptionPlanStoreChange.bind(this);
        this.onUserClick = this.onUserClick.bind(this);
        this.changeUserType = this.changeUserType.bind(this);
        this.changeOrgPlan = this.changeOrgPlan.bind(this);
        this.changePlanStatus = this.changePlanStatus.bind(this);
        this.toggleOwnerDetails = this.toggleOwnerDetails.bind(this);
        this.onOwnerDeleteClick = this.onOwnerDeleteClick.bind(this);
        this.renderMemberDetails = this.renderMemberDetails.bind(this);
        this.renderOwnerDetails = this.renderOwnerDetails.bind(this);
        this.renderOrgPlanChooser = this.renderOrgPlanChooser.bind(this);
        this.setAddOwnerModalState = this.setAddOwnerModalState.bind(this);
        this.toggleAddOwnerModalState = this.toggleAddOwnerModalState.bind(this);
        this.setRemoveOwnerModalState = this.setRemoveOwnerModalState.bind(this);
        this.removeSelectedOwnerFromOrganization = this.removeSelectedOwnerFromOrganization.bind(this);
        this.deselectUser = this.deselectUser.bind(this);
        this.toggleCourseStats = this.toggleCourseStats.bind(this);
        this.renderSelectedOrgStudentCounts = this.renderSelectedOrgStudentCounts.bind(this);
        this.toggleDeleteOrgModal = this.toggleDeleteOrgModal.bind(this);
        this.onDeleteOrg = this.onDeleteOrg.bind(this);

        this.unsubscribes = [
            AdminGlobalUserStore.listen(this.onAdminGlobalUserStoreChange.bind(this)),
            SubscriptionPlanStore.listen(this.onSubscriptionPlanStoreChange.bind(this)),
            OrganizationMemberStore.listen(this.onOrgMemberStoreChange.bind(this)),
            AssignmentStore.listen(this.onAssignmentStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        GlobalUserActions.getOrgs(uuid.v4());
        SubscriptionPlanActions.getPlans(uuid.v4());
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getStateFromPlanStoreState(storeState, selectedUser) {
        var org_plans = [];
        var selected_plan_id = '';
        var selected_status = '';
        var currentPlan = null;
        var currentSubscription = null;
        var selected_user_id = selectedUser ? selectedUser.id : '';
        var get_subscription_action = this.state.get_subscription_action;
        forEach(storeState.plans,function(plan) {
            if (selected_user_id && plan.users) {
                var u = find(plan.users,{user_id: selected_user_id});
                if (u) {
                    currentPlan = plan;
                    selected_plan_id = plan.id;
                }
            }
            if ( (plan.process_type === Globals.ecommerce.process_types.PO) && Globals.users.is_org_account_type(plan.account_type) ) {
                org_plans.push(plan);
            }
        });
        if (currentPlan) {
            let subscription = storeState.user_subscription_plan && storeState.user_subscription_plan.subscription;
            if (subscription && (subscription.user_id == selected_user_id) && (subscription.plan_id == currentPlan.id)) {
                selected_status = currentPlan.status = subscription.status;
            }
            else if (!this.state.get_subscription_action) {
                currentPlan.status = 'loading...';
                get_subscription_action = uuid.v4();
                SubscriptionPlanActions.getSubscriptionPlanForUser(get_subscription_action, { userId: selected_user_id });
            }
        }
        return {
            org_plans,
            selected_plan_id, selected_status,
            currentPlan,
            get_subscription_action
        };
    }

    onAdminGlobalUserStoreChange(state) {
        this.setState({ userStoreState: state });
    }

    onOrgMemberStoreChange(state) {
        this.setState({ organizationMemberState: state });
    }

    onAssignmentStoreChange(state) {
        this.setState({ assignmentStoreState: state });
    }

    onSubscriptionPlanStoreChange(state) {
        let newState = this.getStateFromPlanStoreState(state, this.state.selectedUser);
        let additionalState = {};
        let callback;
        // check to update our organizations after we get the result of the plan change
        if (state.action.id === this.state.user_update_action) {
            additionalState = { ...additionalState, user_update_action: null };
            callback = () => {
                GlobalUserActions.getOrgs(uuid.v4()); // request new users in case something changed
            }
        }
        else if (state.action.id === this.state.get_subscription_action) {
            additionalState = { ...additionalState, get_subscription_action: null };
        }

        return this.setState({ ...newState, ...additionalState }, () => {
            if (!!callback) callback();
        });
    }

    onUserClick(e, userId) {
        if (this.state.selectedUser && (this.state.selectedUser.id === userId)) {
            return;
        }

        const user = find(users, { id: userId });
        const planState = this.getStateFromPlanStoreState(SubscriptionPlanStore.getState(), user);
        const updateLaunchCounts = typeof this.state.userStoreState.launchCounts[userId] === 'undefined';
        var get_subscription_action = uuid.v4();

        this.setState({
            selectedUser: user,
            selectedOwner: null,
            showOwnerDetails: false,
            plan_error: null,
            currentPlan: planState.currentPlan,
            selected_plan_id: planState.selected_plan_id,
            get_subscription_action,
        }, () => {
            OrganizationActions.getMembers(uuid.v4(), { id: userId });
            AssignmentActions.adminGetStudentCountPerIntegrationType(uuid.v4(), { id: userId });
            if (updateLaunchCounts) {
                GlobalUserActions.getLaunchCounts(uuid.v4(), { userId: userId });
            }
            
            SubscriptionPlanActions.getSubscriptionPlanForUser(get_subscription_action, { userId: userId });
        });
    }

    changeUserType(type) {
        this.setState({ viewUserType: type, selectedUser: null });
    }

    changeOrgPlan(new_plan_id) {
        if (this.state.selected_plan_id === new_plan_id) {
            console.log("changeOrgPlan: no change.");
            return;
        }

        if (!this.state.selectedUser) {
            return;
        }

        if (confirm("Are you sure you want to change this organization's plan?")) {
            const actionID = uuid.v4();
            this.setState({ user_update_action: actionID, plan_error: null }, () => {
                const org_id = this.state.selectedUser.id;
                SubscriptionPlanActions.changePurchaseOrderPlan(actionID, org_id, new_plan_id);
            });
        }
    }
    
    changePlanStatus(new_status) {
        if (this.state.selected_status === new_status) {
            console.log("changePlanStatus: no change.");
            return;
        }

        if (!this.state.selectedUser) {
            return;
        }
        
        if (!this.state.currentPlan) {
            return;
        }
        
        if (this.state.currentPlan.process_type !== Globals.ecommerce.process_types.PO) {
            console.log("changePlanStatus: not a PO plan.");
            return;
        }

        if (confirm("Are you sure you want to change this organization's subscription status?")) {
            const actionID = uuid.v4();
            const org_id = this.state.selectedUser.id;
            const plan_id = this.state.currentPlan.id;
            let currentPlan = this.state.currentPlan;
            currentPlan.status = new_status;
            this.setState({ 
                user_update_action: actionID, 
                plan_error: null,
                currentPlan
            }, () => {
                SubscriptionPlanActions.changeSubscriptionStatus(actionID, {
                    user_id: org_id,
                    plan_id: plan_id, // validate that we're changing what we think we're changing
                    status: new_status
                });
            });
        }
    }
    
    toggleOwnerDetails() {
        this.setState({ showOwnerDetails: !this.state.showOwnerDetails });
    }

    onOwnerDeleteClick(owner,evt) {
        evt.stopPropagation();
        this.setState({
            selectedOwner: owner,
            showRemoveOwnerConfirm: owner ? true : false
        });
    }

    renderMemberDetails(members, owners) {
        const self = this;
        return (
            <div className="org-member-details">
                {members.map((m) => {
                    const isAlsoOwner = !!find(owners, { id: m.id });
                    return (
                        <div key={m.id}>
                            <span>{m.email}</span>
                            {(isAlsoOwner) ?
                                <span className="owner-style">{' (owner)'}</span>
                                :
                                <button
                                    className="bare-text-button glyph"
                                    onClick={this.onOwnerDeleteClick.bind(this, m)}
                                >
                                    <i className="fa fa-remove remove-owner-icon" />
                                </button>
                            }
                        </div>
                    );
                })}
                <br/>
            </div>
        );
    }

    renderOwnerDetails(owners) {
        return (
            <div className="org-member-details">
                {owners.map((m) =>
                    <div key={m.id}>
                        <span>{m.email}</span>
                        <button
                            className="bare-text-button glyph"
                            onClick={this.onOwnerDeleteClick.bind(this, m)}
                        >
                            <i className="fa fa-remove remove-owner-icon" />
                        </button>
                    </div>
                )}
            </div>
        );
    }

    renderOrgPlanChooser() {
        if (!this.state.org_plans || !this.state.org_plans.length ) {
            return null;
        }
        if (!this.state.selectedUser) {
            return null;
        }

        if (this.state.currentPlan && this.state.currentPlan.process_type === Globals.ecommerce.process_types.CC) {
            return (
                <div className="org-plan-readonly">
                    <label>Subscription Plan:</label>
                    <span>{this.state.currentPlan.display_name}</span>
                    <br/>
                    <label>Status:</label>
                    <span>{this.state.currentPlan.status}</span>
                </div>
            )
        }

        // console.log("renderOrgPlanChooser selectedUser: " + JSON.stringify(this.state.selectedUser)); // TODO: check account_type and/or selected_plan_id.  Don't allow changing CC types (only PO types) ?

        var self = this;
        var currentPlan = this.state.currentPlan;
        var selectedPlan; // = find(this.state.org_plans,{id: this.state.org_plan_id});
        const planMenuItems = this.state.org_plans.map((plan) => {
            let itemClass = 'AriaMenuButton-menuItem';
            if(self.state.selected_plan_id === plan.id) {
                itemClass += ' is-selected';
                selectedPlan = plan;
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={plan.id}>
                    <MenuItem
                    className={itemClass}
                    value={plan.id}
                    text={plan.display_name}>
                        {plan.display_name}
                    </MenuItem>
                </li>
            );
        });
        
        var selectedStatus;
        const statusMenuItems = STATUS_VALUES.map((status) => {
            let itemClass = 'AriaMenuButton-menuItem';
            if(currentPlan && currentPlan.status === status) {
                itemClass += ' is-selected';
                selectedStatus = status;
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={status}>
                    <MenuItem
                    className={itemClass}
                    value={status}
                    text={status}>
                        {status}
                    </MenuItem>
                </li>
            );
        });

        return  (
            <div className="org-plan-chooser">
                <label htmlFor="plan-interval">Subscription Plan</label>
                <Wrapper id="plan-interval" className='AriaMenuButton margin-left-sm' onSelection={this.changeOrgPlan}>
                    <AriaButton className='AriaMenuButton-trigger'>
                        {selectedPlan ? selectedPlan.display_name : 'select a plan'}
                    </AriaButton>
                    <Menu>
                        <ul className='AriaMenuButton-menu'>
                            {planMenuItems}
                        </ul>
                    </Menu>
                </Wrapper>

                <br/>

                <label htmlFor="plan-interval">Plan Status</label>
                <Wrapper id="status-interval" className='AriaMenuButton margin-left-sm' onSelection={this.changePlanStatus}>
                    <AriaButton className='AriaMenuButton-trigger'>
                        {selectedStatus ? selectedStatus : 'select status'}
                    </AriaButton>
                    <Menu>
                        <ul className='AriaMenuButton-menu'>
                            {statusMenuItems}
                        </ul>
                    </Menu>
                </Wrapper>


                <ErrorBox error={self.state.plan_error}/>
            </div>
        );
    } // renderOrgPlanChooser

    setAddOwnerModalState(b) {
        this.setState({ showAddOwnerPanel: b });
    }

    toggleAddOwnerModalState() {
        this.setState({ showAddOwnerPanel: !this.state.showAddOwnerPanel });
    }

    setRemoveOwnerModalState(b) {
        this.setState({ showRemoveOwnerConfirm: b });
    }

    removeSelectedOwnerFromOrganization() {
        const actionId = uuid.v4();
        OrganizationActions.removeOrganizationMember(actionId, {
            orgId: this.state.selectedUser.id,
            userId: this.state.selectedOwner.id
        });
        this.setState({
            showRemoveOwnerConfirm: false,
            selectedOwner: null
        });
    }

    deselectUser() {
        this.setState({ selectedUser: null });
    }

    toggleCourseStats() {
        this.setState({ showCourseStats: !this.state.showCourseStats });
    }
    
    toggleVoiceUsage=()=>{
        this.setState({showVoiceUsage: !this.state.showVoiceUsage});
    }
    
    toggleChatbotUsage=()=>{
        this.setState({showChatbotUsage: !this.state.showChatbotUsage});
    }


    renderSelectedOrgStudentCounts(user) {
        if (!user) {
            return null;
        }
        if (!this.state.assignmentStoreState) {
            return null;
        }
        if (!this.state.assignmentStoreState.userAssignmentStudentCounts) {
            return null;
        }
        if (this.state.assignmentStoreState.userAssignmentStudentCounts.loading) {
            return ( <li>{'Loading Student Counts...'}</li> );
        }

        var studentCounts = this.state.assignmentStoreState.userAssignmentStudentCounts[user.id];
        if (!studentCounts || studentCounts.length === 0) {
            return ( <li>No LTI Students</li> );
        }

        var elems = [];
        forEach(studentCounts,function(elem) {
            var integrationTitle;
            switch (elem.integrationType) {
                case 'gc':
                    integrationTitle = 'Google Classroom Students';
                    break;
                case 'mzl':
                    integrationTitle = 'Local Assignment Students';
                    break;
                case 'lti':
                    integrationTitle = 'LTI Assignment Students';
                    break;
                case 'none':
                    integrationTitle = 'Non Integration Students'; // is this possible?
                    break;
                default:
                    integrationTitle = elem.integrationType + " Assignment Students";
            }
            elems.push(
                <li key={'integration_heading_' + elem.integrationType}>
                    <div className="user-view-student-count-row">
                        <h1>{integrationTitle + ': '  + elem.studentCount}</h1>
                    </div>
                </li>
            )
        });
        return (
            <li>
                <div className="col-sm-12 user-view-student-counts">
                    <ul>{elems}</ul>
                </div>
            </li>
        )
    }

    toggleDeleteOrgModal(visible, userIdToDelete) {
        this.setState({ deleteOrgModalVisible: visible, userIdToDelete: userIdToDelete || null });
    }

    onDeleteOrg() {
        const actionId = uuid.v4();
        const userIdToDelete = this.state.userIdToDelete;

        this.setState(
            {
                userIdToDelete: null,
                deleteOrgModalVisible: false,
                deleteActionId: actionId,
                selectedUser: this.state.selectedUser.id === userIdToDelete ? null : this.state.selectedUser,

            }, () => {
                GlobalUserActions.deleteUser(actionId, userIdToDelete);
            }
        );
    }

    render() {
        const _this = this;
        let userContent;
        users = this.state.userStoreState['orgs'];
        const maxUsersForWarning = get(this.state.userStoreState, 'userPagination.orgs.recordsPerPage', null);

        if (this.state.selectedUser) {
            var _user = this.state.selectedUser;
            var _launchCount = this.state.userStoreState.launchCounts[_user.id];

            var memberElem;
            if (this.state.organizationMemberState && this.state.organizationMemberState.members) {
                var members = this.state.organizationMemberState.members[_user.id];
                // sort by email address, domain first
                members = sortBy(members,function(m) {
                    if (m.email) {
                        var parts = m.email.toLowerCase().split('@');
                        if (parts.length == 2) {
                            return parts[1] + ' ' + parts[0];
                        }
                        return m.email;
                    }
                    return 'zzzz';
                });
                var owners = filter(members,function(m) {
                        return (m.role_token === Globals.users.roles.CHANNEL_OWNER) ||(m.role_token === Globals.users.roles.ORG_OWNER);
                    });
                if (members) {
                    memberElem = (
                        <li onClick={this.toggleOwnerDetails}>
                            <div>Members: {members.length}</div>
                            {this.renderMemberDetails(members,owners)}
                            <div>Owners: {owners.length}</div>
                            {this.renderOwnerDetails(owners)}
                        </li>
                    );
                }
            }

            var addOwnerControls = (
                <div>
                    <Button onClick={this.toggleAddOwnerModalState}>Add Owner</Button>
                    {(this.state.showAddOwnerPanel) &&
                        <AdminAddOrgOwnerModal
                            show
                            closeHandler={this.setAddOwnerModalState.bind(this, false)}
                            orgId={this.state.selectedUser.id}
                        />
                    }
                    {(this.state.showRemoveOwnerConfirm) &&
                        <ConfirmModal
                            show={true}
                            modalTitle="Remove Owner"
                            text={"Are you sure you want to remove " + this.state.selectedOwner.email + " from the organization?"}
                            buttonText="remove"
                            closeHandler={this.setRemoveOwnerModalState.bind(this, false)}
                            confirmHandler={this.removeSelectedOwnerFromOrganization}
                        />
                    }
                </div>
            );

            userContent = (
                <Card body bg="light" className="user-info">
                    <h1 className="margin-bottom-lg">{_user.display_name}</h1>

                    <div className="margin-bottom-lg">
                        <h3>Organization Information</h3>
                        <hr className="thick hr-color-5"/>
                        <ul>
                            <li>Created at: {!!_user.created_at ? <DateString date={_user.created_at} showTime={true}/> : 'Unknown'}</li>
                            <li>Last active at: {!!_user.active_at ? <DateString date={_user.active_at} showTime={true}/> : 'Unknown'}</li>
                            <li>Email: {_user.email}</li>
                            {memberElem}
                            {addOwnerControls}
                            {this.renderSelectedOrgStudentCounts(_user)}
                            {has(_user, 'project_count') ? <li>Owned Projects: {_user.project_count}</li> : null}
                            {has(_user, 'activity_count') ? <li>Owned Activities: {_user.activity_count}</li> : null}
                            {_launchCount ? <li>Owned Activity Launches: {_launchCount}</li> : null}
                            {has(_user, 'shared_project_count') ? <li>Shared Projects: {_user.shared_project_count}</li> : null}
                            {has(_user, 'shared_activity_count') ? <li>Shared Activities: {_user.shared_activity_count}</li> : null}
                            <li>Registration Token: {_user.registration_token}</li>
                        </ul>
                    </div>

                    {(GlobalConfig.DebugMode) &&
                        <div className="margin-bottom-lg">
                            <h3 className="heading-lg">Delete organization</h3>
                            <hr className="thick hr-color-5"/>
                            <Button variant="danger" onClick={this.toggleDeleteOrgModal.bind(this, true, _user.id)}>Delete Organization</Button>
                        </div>
                    }
                    
                    <hr className="thick hr-color-5"/>
                    <div className="margin-bottom-lg">
                        <button title="Toggle Course Stats" className="btn btn-primary" onClick={this.toggleCourseStats}>{this.state.showCourseStats ? 'Hide Course Stats' : 'Course Stats'}</button>
                        {this.state.showCourseStats ?
                        <CourseStatsView className="margin-top-lg" channelId={_user.id} orgName={_user.display_name} />
                        : null }
                        <hr className="thick hr-color-5"/> 
                    </div>

                    <div className="margin-bottom-lg">
                        <h3 className="heading-lg">Partner Information</h3>
                        <hr className="thick hr-color-5"/>
                        <AdminUserPartnerKeyEditor user={_user} />
                        { _user.third_party_id ? null : <AdminLTISettingsView user={_user} /> }
                    </div>

                    <div className="margin-bottom-lg">
                        <h3 className="heading-lg">Plan</h3>
                        <hr className="thick hr-color-5"/>
                        {this.renderOrgPlanChooser()}
                    </div>

                    <div className="margin-bottom-lg">
                        <h3 className="heading-lg">Template Permissions</h3>
                        <hr className="thick hr-color-5"/>
                        <AdminUserTemplatePermissionsEditor user={_user} />
                    </div>
                    
                    <div className="margin-bottom-lg">
                        <h3 className="heading-lg">Account Features</h3>
                        <hr className="thick hr-color-5"/>
                        <AdminAccountFeaturesEditor user={_user} />
                        <hr className="thick" style={{background:'none'}}/>
                        <button title="Toggle Voice Usage" className="btn btn-primary" onClick={this.toggleVoiceUsage}>{this.state.showVoiceUsage ? 'Hide Voice Usage' : 'Voice Usage'}</button>
                        {this.state.showVoiceUsage ?
                        <VoiceUsageView className="margin-top-lg" channelId={_user.id} orgName={_user.display_name} />
                        : null }
                        <button title="Toggle Chatbot Usage" className="btn btn-primary" onClick={this.toggleChatbotUsage}>{this.state.showChatbotUsage ? 'Hide Chatbot Usage' : 'Chatbot Usage'}</button>
                        {this.state.showChatbotUsage ?
                        <ChatbotUsageView className="margin-top-lg" channelId={_user.id} orgName={_user.display_name} />
                        : null }
                    </div>

                    <div className="margin-bottom-lg">
                        <h3 className="heading-lg">WebSketches</h3>
                        <hr className="thick hr-color-5"/>
                        <ExpansionButton
                            disabled={false}
                            expanded={this.state.showWebSketchSection}
                            ariaText="Web Sketches"
                            onClick={()=>{this.setState({showWebSketchSection:!this.state.showWebSketchSection})}}
                            expandedIcon="fa-caret-square-o-down"
                            collapsedIcon="fa-caret-square-o-right"
                        />
                        { this.state.showWebSketchSection ? 
                            <div className="margin-bottom-lg">
                                <AdminOrgWebSketchUploads org_id={_user.id} />
                            </div>
                        : null }
                    </div>
                </Card>
            );
        }

        return (
            <div>
                {this.state.selectedUser ?
                    <button className="btn" onClick={this.deselectUser}>{'Back to list'}</button>
                    :
                    <div>
                        <h2 className="view-title">
                            Register Organization
                        </h2>
                        <Card body bg="light">
                            <RegisterOrganization payMethodTypes={[Globals.ecommerce.process_types.PO]} />
                        </Card>
                        {(!!maxUsersForWarning) &&
                            <WarningBox>
                                This table will only display {maxUsersForWarning} records before requiring a client re-write to utilize pagination.
                            </WarningBox>
                        }
                        <SortableTableClassic title="Organizations"
                            key="t-user"
                            onRowClick={this.onUserClick}
                            rows={users}
                            selectedRowKey={!!this.state.selectedUser ? this.state.selectedUser.id : null}
                            dateFormat="YYYY-MM-DD HH:mm:ss"
                            columns={ORG_COLUMN_DATA}
                        />
                    </div>
                }
                {userContent}
                {this.state.deleteOrgModalVisible &&
                    <ConfirmModal
                        show
                        modalTitle="Delete Organization"
                        text="Are you sure you want to delete this organization? All information related to this organization will be permanently deleted."
                        buttonText="delete"
                        closeHandler={this.toggleDeleteOrgModal.bind(this, false)}
                        confirmButtonBsStyle="danger"
                        confirmHandler={this.onDeleteOrg}
                    />
                }
            </div>
        );
    }
}

AdminOrganizationView.propTypes = propTypes;
AdminOrganizationView.defaultProps = defaultProps;

export default AdminOrganizationView;
